
<div class="col-xs-12" *ngIf="!coupon">
  <button class="btn btn-xxs" (click)="applyCoupon()">Apply Coupon</button>
</div>
<div class="col-xs-12" *ngIf="coupon">
  <div class="col-xs-12 no-padder no-margin"><span class="pR15">Coupon Applied :</span><a class="btn btn-success btn-sm" routerLink="/ecom/coupons" [queryParams]="{ code: coupon.get('code') }">{{coupon.get('code')}}</a></div>
</div>